export default class HtmlArgUtil
{
	static htmlarg;
}


// WEBPACK FOOTER //
// ./src/utils/HtmlArgUtil.js